/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Not Found Problem schema.
 */
export interface ProblemBlobNotFound {
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string;
    /** Optional list of individual error details */
    errors?: Truvity.ErrorDetail[];
    /**
     * The primary and unique identifier of the resource (inside tenant)
     * according to [RFC 4122](https://www.rfc-editor.org/info/rfc4122).
     */
    id: string;
    /** A URI reference that identifies the specific occurrence of the problem. */
    instance?: string;
    kind: string;
    /** HTTP status code */
    status: number;
    /** This value should not change between occurrences of the error. */
    title: string;
}
